// local date/time format is YYYY-MM-DDTmm:dd[:ss]
export const convertDateTimeFromUTCToLocal = (d: string) => {
  if (!d) {
    return d;
  }
  const dt = new Date(d);
  return new Date(dt.getTime() - dt.getTimezoneOffset() * 60 * 1000).toISOString().substring(0, 19);
};

// goes all US on me when I replace "en-GB" with undefined even though my machine's Timezone is Europe/London...
const DATE_FORMATTER = new Intl.DateTimeFormat('en-GB', {
  year: '2-digit',
  month: '2-digit',
  day: '2-digit',
});

export const displayLocaleDate = (d: Date | string | number) => {
  try {
    return DATE_FORMATTER.format(typeof d === 'object' ? d : new Date(d));
  } catch (e) {
    return 'error';
  }
};

const DTTM_FORMATTER = new Intl.DateTimeFormat('en-GB', {
  year: '2-digit',
  month: '2-digit',
  day: '2-digit',
  hour: 'numeric',
  minute: 'numeric',
  second: 'numeric',
  hour12: false,
});

export const displayLocaleDateTime = (d: Date | string | number): string => {
  try {
    return DTTM_FORMATTER.format(typeof d === 'object' ? d : new Date(d));
  } catch (e) {
    return 'error';
  }
};

export const displayLocaleTime = (d: Date | string | number): string => {
  try {
    return (typeof d === 'object' ? d : new Date(d)).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  } catch (e) {
    return 'error';
  }
};

// TODO: redo this without depending on the character positions of the time parts of the string
export const displayDateTimeToMinute = (d: Date | string | number, ifNoDate: string = ''): string =>
  !d ? ifNoDate : displayLocaleDateTime(typeof d === 'object' ? d : new Date(d)).substring(0, 15);

export const getFirstDateOfMonth = (date: Date): Date => {
  return new Date(date.getFullYear(), date.getMonth(), 1);
};

export const getLastDateOfMonth = (date: Date): Date => {
  return new Date(date.getFullYear(), date.getMonth() + 1, 0);
};

export const getLastDateOfMonthPlusOne = (date: Date): Date => {
  return new Date(date.getFullYear(), date.getMonth() + 1, 1);
};

export const getLastDayOfMonth = (date: Date): number => {
  return getLastDateOfMonth(date).getDate();
};

export const getMonthName = (date: Date): string => {
  return date.toLocaleString('default', { month: 'long' });
};
